<script setup lang="ts">
  import DocumentProcessingStatus from '@/components/app/cases/documents/DocumentProcessingStatus.vue'
  import Entities from '@/components/app/cases/entities/Entities.vue'
  import TEMPORARYCaseBaseComponent from '@/components/app/cases/TEMPORARYCaseBaseComponent.vue'
  import { useTranslation } from '@/composables/useTranslation'
  import { useCaseStore } from '@/store/app/case/detail/caseDetailStore'
  import { CheckCircle, Loader2 } from 'lucide-vue-next'

  const { t } = useTranslation({
    en: {
      DocumentsBeingAnalyzedDataUpdate:
        'Documents are being analyzed, data will be updated soon. You can leave the tab and review the data later.',
      AllDocumentsAnalyzed: 'All documents have been analyzed'
    },
    de: {
      DocumentsBeingAnalyzedDataUpdate:
        'Dokumente werden analysiert, Daten werden bald aktualisiert. Sie können den Tab verlassen und die Daten später überprüfen.',
      AllDocumentsAnalyzed: 'Alle Dokumente wurden analysiert'
    }
  })

  // Get document processing data for DocumentProcessingStatus
  const caseStore = useCaseStore()
  const documentProcessor = caseStore.documentProcessor
</script>

<template>
  <div class="h-full w-full">
    <TEMPORARYCaseBaseComponent>
      <div class="mt-4">
        <DocumentProcessingStatus
          key="temporary-entities-document-status"
          :use-slots="true"
          :documents="documentProcessor.documents"
          :processing-documents="documentProcessor.processingDocuments"
          :active-uploads="documentProcessor.activeUploads"
          :documents-with-errors="documentProcessor.documentsWithErrors"
        >
          <template #default="{ hasActivity, showSuccessMessage }">
            <div
              v-if="hasActivity || showSuccessMessage"
              class="flex w-full items-center justify-center gap-2 rounded-md px-4 py-3 text-sm"
              :class="[
                hasActivity
                  ? 'border border-purple-200 bg-purple-50 text-purple-700'
                  : 'border border-green-200 bg-green-50 text-green-700'
              ]"
            >
              <div class="flex items-center gap-2">
                <Loader2
                  v-if="hasActivity"
                  class="h-4 w-4 animate-spin text-purple-500"
                />
                <CheckCircle
                  v-else
                  class="h-4 w-4 text-green-500"
                />
                <span>
                  {{
                    hasActivity ? t('DocumentsBeingAnalyzedDataUpdate') : t('AllDocumentsAnalyzed')
                  }}
                </span>
              </div>
            </div>
          </template>
        </DocumentProcessingStatus>
      </div>
      <!-- Document Processing Status -->
      <div class="mt-4">
        <Entities />
      </div>
    </TEMPORARYCaseBaseComponent>
  </div>
</template>
